const inkTonerConfig = {
	brand: {
		selectedOption: {},
		options: [],
		propertiesToReset: ['series', 'model'],
	},
	series: {
		selectedOption: {},
		options: [],
		propertiesToReset: ['model'],
	},
	model: {
		selectedOption: {},
		options: [],
		propertiesToReset: [],
	},
};

export default inkTonerConfig;
